export const USER_LOADING = 'USER_LOADING';

export const USER_READY = 'USER_READY';

export const UPDATE_USER_HEATMAP_SETTINGS = 'UPDATE_USER_HEATMAP_SETTINGS';

export const UPDATE_USER_PORTFOLIO_SETTINGS = 'UPDATE_USER_PORTFOLIO_SETTINGS';

export const UPDATE_USER_HOLDINGS_SETTINGS = 'UPDATE_USER_HOLDINGS_SETTINGS';

export const UPDATE_USER_HOMEPAGE_PREFERENCE = 'UPDATE_USER_HOMEPAGE_PREFERENCE';

export const UPDATE_USER_PEER_GROUPS_SETTINGS = 'UPDATE_USER_PEER_GROUPS_SETTINGS';

export const UPDATE_USER_INSTRUMENTS_SETTINGS = 'UPDATE_USER_INSTRUMENTS_SETTINGS';
